export enum Action {
  COMPLETE_ONBOARDING = 'action_complete_onboarding',
  NO_LENDER_REQUEST_ID = 'action_no_lender_request_id',
  PAY = 'action_pay',
  UPLOAD_DOCUMENTS = 'action_upload_documents',
  REVIEW_DOCUMENTS = 'action_revise_documents',
  SIGN_CONTRACT = 'action_sign_contract',
  COMPLETE_PROCESS_SANTANDER = 'action_complete_process_santander',
  PAY_FIRST_INSTALMENT = 'action_pay_first_instalment',
  CAPTURE_ORDER = 'action_capture_order',
  COMPLETE_KYC = 'action_complete_kyc',
  VALIDATE_CARD_DATA = 'action_validate_card_data',
  PRINT_CARD = 'action_print_card',
}
